import axios from "axios";
import { getAccessToken } from "./utils.js";
import { getUrl } from "./urls";
import { toast } from "react-toastify";

export const HISTORIC_LIST = "HISTORIC_LIST";
export const CREATE_MODE = "CREATE_MODE";
export const GENERATE_VOLUME = "GENERATE_VOLUME";
export const CREATE_HISTORIC = "CREATE_HISTORIC";
export const RESET_VOLUME = "RESET_VOLUME";

export function fetchHistoricData() {
    let res = axios({
        method: "get",
        url: getUrl("historic_list"),
        cache: false,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => res.data)
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });

    return {
        type: HISTORIC_LIST,
        payload: res,
    };
}

export function createHistoricMode(flag) {
    return {
        type: "CREATE_MODE",
        payload: flag,
    };
}

export function generateDataVolumeEstimate(params) {
    let res = axios({
        method: "post",
        data: params,
        url: getUrl("generate_volume"),
        cache: false,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => res.data)
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });
    return {
        type: "GENERATE_VOLUME",
        payload: res,
    };
}

export function createHistoric(params) {
    let res = axios({
        method: "post",
        data: params,
        url: getUrl("create_historic"),
        cache: false,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success(res.data.message);
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: "CREATE_HISTORIC",
        payload: res,
    };
}
export function resetVolumeEstimate() {
    return {
        type: RESET_VOLUME,
        payload: "",
    };
}
